<template>
  <div id="loan-list-bl">
    <section :class="['amount', isUseingLimit ? 'is-useing-limit' : '']" v-if="!showData">
      <div class="amount-item" v-if="myLoanData.showList.includes('1')">
        <span class="amount-title">已还款金额</span>
        <!-- <span class="amount-title-en">Repayment amount</span> -->
        <span :style="{fontSize:scaleSize(myLoanData.yhSum)}" class="amount-money"><em>￥</em>{{myLoanData.yhSum  | addThousandSign(2)}}</span>
      </div>
      <div class="amount-item" v-if="myLoanData.showList.includes('2')">
        <span class="amount-title">未还款金额</span>
        <!-- <span class="amount-title-en">Outstanding amount</span> -->
        <span :style="{fontSize:scaleSize(myLoanData.whSum)}" class="amount-money"><em>￥</em>{{myLoanData.whSum  | addThousandSign(2)}}</span>
      </div>
      <div v-if="myLoanData.showList.includes('3')"
           class="amount-item">
        <span class="amount-title">总授信额度</span>
        <!-- <span class="amount-title-en">Available credit</span> -->
        <span :style="{fontSize:scaleSize(myLoanData.limitMoneySum)}" class="amount-money"><em>￥</em>{{myLoanData.limitMoneySum  | addThousandSign(2)}}</span>
      </div>
      <div 
      v-if="myLoanData.showList.includes('4')"
           class="amount-item">
        <span class="amount-title">总应收账款金额</span>
        <!-- <span class="amount-title-en">Total lines</span> -->
        <!-- <span class="amount-money"><em>￥</em>{{myLoanData.allReceivableAmountSum | addThousandSign(2)}}</span> -->
        <span :style="{fontSize:scaleSize(myLoanData.allReceivableAmountSum)}" class="amount-money"><em>￥</em>{{myLoanData.allReceivableAmountSum  | addThousandSign(2)}}</span>
      </div>
    </section>
    <div class="info-amount" v-if="myLoanData.showList.includes('5') || myLoanData.showList.includes('6') || myLoanData.showList.includes('7') || myLoanData.showList.includes('8')">
      <div class="info-amount-item" v-if="myLoanData.showList.includes('5')">
        <span class="info-amount-first">已还本金</span>
        <span class="info-amount-money"
              :title="myLoanData.yhbjSum">￥{{myLoanData.yhbjSum  | addThousandSign(2)}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-amount-item"  v-if="myLoanData.showList.includes('6')">
        <span class="info-amount-first">已还保理费</span>
        <span class="info-amount-money"
              :title="myLoanData.yhblfSum">￥{{myLoanData.yhblfSum  | addThousandSign(2)}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-amount-item"  v-if="myLoanData.showList.includes('7')">
        <span class="info-amount-first">已还服务费</span>
        <span class="info-amount-money"
              :title="myLoanData.yhfwfSum">￥{{myLoanData.yhfwfSum  | addThousandSign(2)}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-amount-item"  v-if="myLoanData.showList.includes('8')">
        <span class="info-amount-first">已使用授信额度</span>
        <span class="info-amount-money"
              :title="myLoanData.limitUsedSum">￥{{myLoanData.limitUsedSum  | addThousandSign(2)}}</span>
      </div>
    </div>
    <div class="info-amount info-amount-second" v-if="myLoanData.showList.includes('9') || myLoanData.showList.includes('10') || myLoanData.showList.includes('11') || myLoanData.showList.includes('12')">
      <div class="info-amount-item"  v-if="myLoanData.showList.includes('9')">
        <span class="info-amount-first">未还本金</span>
        <span class="info-amount-money"
              :title="myLoanData.whbjSum">￥{{myLoanData.whbjSum  | addThousandSign(2)}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-amount-item"  v-if="myLoanData.showList.includes('10')">
        <span class="info-amount-first">未还保理费</span>
        <span class="info-amount-money"
              :title="myLoanData.whblfSum">￥{{myLoanData.whblfSum  | addThousandSign(2)}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-amount-item"  v-if="myLoanData.showList.includes('11')">
        <span class="info-amount-first">未还服务费</span>
        <span class="info-amount-money"
              :title="myLoanData.whfwfSum">￥{{myLoanData.whfwfSum  | addThousandSign(2)}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-amount-item" v-if="myLoanData.showList.includes('12')">
        <span class="info-amount-first">未使用授信额度</span>
        <span class="info-amount-money"
              :title="myLoanData.limitAvailableSum">￥{{myLoanData.limitAvailableSum  | addThousandSign(2)}}</span>
      </div>
    </div>
    <!--<section class="info-card">-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">已还本金</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.yhbjSum }}</span>-->
    <!--<i class="vertical-line"></i>-->
    <!--</div>-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">已还保理费</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.yhblfSum}}</span>-->
    <!--<i class="vertical-line"></i>-->
    <!--</div>-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">已还服务费</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.yhfwfSum}}</span>-->
    <!--<i class="vertical-line"></i>-->
    <!--</div>-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">已使用授信额度</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.limitUsedSum}}</span>-->
    <!--<i class="vertical-line"></i>-->
    <!--</div>-->
    <!--</section>-->
    <!--<section class="info-card" style="margin-top:0px;">-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">未还本金</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.whbjSum}}</span>-->
    <!--<i class="vertical-line"></i>-->
    <!--</div>-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">未还保理费</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.whblfSum}}</span>-->
    <!--</div>-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">未还服务费</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.whfwfSum}}</span>-->

    <!--<i class="vertical-line"></i>-->
    <!--</div>-->
    <!--<div class="info-card-item">-->
    <!--<span class="info-card-item-ch">未使用授信额度</span>-->
    <!--<span class="info-card-item-num">￥{{myLoanData.limitAvailableSum}}</span>-->
    <!--</div>-->
    <!--</section>-->
    <section class="loan-lists">
      <el-tabs :active-name="activeName"
               @tab-click="handleClick"
               class="cur">
        <el-tab-pane v-for="item in labelName"
                     :label="item.label"
                     :name="item.state"
                     :frontApplyState="item.name"
                     :key="item.name"></el-tab-pane>
      </el-tabs>
      <router-view></router-view>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import MyLoanApi from '../../api/myloan_bl.js';

export default {
  data () {
    return {
      showData: false,
      scaleNum: 1,
      labelName: [
        {
          label: '全部',
          name: '0',
          state: 'all'
        },
        {
          label: '审批中',
          name: '2',
          state: 'shz'
        },
        {
          label: '审批通过',
          name: '3',
          state: 'shtg'
        },
        {
          label: '审批不通过',
          name: '4',
          state: 'shbtg'
        },
        {
          label: '已放款',
          name: '32',
          state: 'yfk'
        },
        {
          label: '已结清',
          name: '33',
          state: 'yjq'
        }
      ],
      myLoanData: {
        whblfSum: 0,
        yhbjSum: 0,
        yhfwfSum: 0,
        yhSum: 0,
        limitMoneySum: 0,
        whbjSum: 0,
        whSum: 0,
        limitUsedSum: 0,
        whfwfSum: 0,
        allReceivableAmountSum: 0,
        yhblfSum: 0,
        limitAvailableSum: 0,
        showList: []
      } // 获取展示数据
    };
  },
  computed: {
    ...mapGetters({
      activeName: types.ACTIVE_NAME,
      userInfo: types.GET_USER,
      // myLoanData: types.MY_LOAN_DATA,
      frontApplyState: types.FRONT_APPLY_STATE,
      isUseingLimit: types.IS_USEING_LIMIT
    })
  },
  created () {
    // this.factoringData();
  },
  methods: {
    ...mapMutations({
      setFrontApplyState: types.SET_FRONT_APPLY_STATE,
      setActiveName: types.SET_ACTIVE_NAME
    }),
    ...mapActions({
      getMyloanData: types.GET_MY_LOAN_DATA
    }),
    handleClick (tab) {
      this.$router.push({
        path: '/personalCenter/myLoan_bl/loanLists_bl',
        query: {
          frontApplyState: this.frontApplyState,
          pageCount: 1,
          applyState: tab.name
        }
        // query: {frontApplyState: this.frontApplyState, pageCount: 1,applyState:tab.name}
      });
    },

    // 保理展示数据
    factoringData () {
      const _this = this;

      MyLoanApi.getMyBlItemInfoCount({
        tokenId: localStorage.getItem('dl_tokenId_bl')
      })
        .then((res) => {
          if (res.rspcode == 1) {
            _this.myLoanData = res.data;
            if (this.showList.length > 0) {
              this.showData = true;
            } else {
              this.showData = false;
            }
          } else {
          }
        })
        .catch((error) => {});
    },
    getInfo () {
      // 9/12

      MyLoanApi.getMyBlItemInfoCount({
        // 详情
        tokenId: localStorage.getItem('dl_tokenId_bl')
      })
        .then((res) => {
          if (res.rspcode == 1) {
            this.myLoanData.whblfSum = res.data.whblfSum;
            this.myLoanData.yhbjSum = res.data.yhbjSum;
            this.myLoanData.yhfwfSum = res.data.yhfwfSum;
            this.myLoanData.yhSum = res.data.yhSum;
            this.myLoanData.whSum = res.data.whSum;
            this.myLoanData.showList = res.data.showList;
            this.myLoanData.limitMoneySum = res.data.limitMoneySum;
            // res.data.limitMoneySum;
            this.myLoanData.whbjSum = res.data.whbjSum;
            this.myLoanData.limitUsedSum = res.data.limitUsedSum;
            this.myLoanData.whfwfSum = res.data.whfwfSum;
            this.myLoanData.allReceivableAmountSum =
              res.data.allReceivableAmountSum;
            this.myLoanData.yhblfSum = res.data.yhblfSum;
            this.myLoanData.limitAvailableSum = res.data.limitAvailableSum;
          } else {
          }
        })
        .catch((error) => {});
    },
    scaleSize (scaleNum) {
      console.log(scaleNum);
      // let scaleNum = Math.max(...arr);
      var k = 10000,
      i;
      i = Math.log(scaleNum) / Math.log(k);
      if (i > 1) {
        this.scaleNum = (1 / i + 0.2);
        let caleNum = 25 * (1 / i + 0.2);
        return `${caleNum}px`;
      } else {
        this.scaleNum = 1;
        return `25px`;
      }
    }
  },
  mounted () {
    const num = 2299000;
    const aaa = `${num.toFixed(0)}`.replace(
      /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
      '$&,'
    );
    // this.factoringData();
    this.getInfo();
    /* this.getMyloanData({
        token: this.userInfo.token,
        frontApplyState: 0,
        pageCurrent: 1
      }) */
    this.$router.push({
      path: '/personalCenter/myLoan_bl/loanLists_bl',
      query: { frontApplyState: 0, pageCount: 1, applyState: 'all' }
    });
  }
};
</script>
<style lang='scss'>
#loan-list-bl {
  position: relative;
  left: 20px;
  .info-amount {
    width: 100%;
    background-color: #fff;
    height: 70px;
    // line-height: 70px;
    color: #3e454d;
    font-size: 14px;
    margin-top: 20px;
    overflow: hidden;
    .info-amount-item {
      width: 25%;
      // display: inline-block;
      float: left;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      overflow: hidden;
      .info-amount-first {
        // padding-left: 30px;
        // position: absolute;
        width: 100%;
        text-align: center;
        // flex: 1;
      }
      .info-amount-money {
        margin-top: 10px;
        display: inline-block;
        color: #EB662B;
        overflow: hidden;
        // width: 90px;
        width: 100%;
        text-align: center;
        // padding-left: 46%;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .info-amount-long {
        padding-left: 60%;
      }
      .vertical-line {
        position: absolute;
        right: 0;
        top: 0px;
        margin-top: 18px;
        width: 1px;
        height: 30px;
        border-right: 1px solid #e8e8e8;
      }
    }
  }
  .info-amount-second {
    margin-top: 0;
  }
}

.amount {
  overflow: hidden;
  .amount-item {
    display: inline-block;
    height: 187px;
    width: 437px;
    overflow: hidden;
    margin-left: 11px;
    background: #fff url("../../../static/images/Columns.png") no-repeat center 126px;

    &:first-child {
      margin-left: 0;
    }

    .amount-title {
      margin-top: 40px;
      font-size: 18px;
      color: #333;
      font-family: "FZLanTingHei-DB-GBK";
    }

    .amount-title-en {
      margin-top: 7px;
      font-size: 13px;
      color: #3e454d;
      font-family: "MyriadPro-Regular";
    }

    .amount-money {
      margin-top: 10px;
      font-size: 25px;
      font-weight: bold;
      color: #EB662B;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      font-family: "MyriadPro-Bold";
      em {
        font-style: normal;
        // font-size: 26px;
        font-family: "Microsoft YaHei";
      }
    }
  }

  span {
    display: block;
    width: 100%;
    text-align: center;
  }
}

// 还没有贷款额度
 .is-useing-limit {
  .amount-item {
    width: 207px;
    margin-left: 15px;
    background: #fff url("../../../static/images/Columns.png") no-repeat center 144px;

   

    .ask-amount-btn {
      width: 92px;
      height: 30px;
      display: block;
      margin: 15px auto;
      border-radius: 2px;
      cursor: pointer;
      background: $orange;
      line-height: 30px;
      font-size: 14px;
      color: $white;
      font-family: "FZLanTingHei-B", "Microsoft YaHei";
    }
  }
}

.amount,
.info-card,
.loan-lists {
  position: relative;
  margin-top: 20px;
  width: 100%;
}

.info-card,
.repayment-amount,
.outstanding-amount,
.loan-lists {
  border-radius: 2px;
  background: #fff;
}

.loan-lists {
  margin-bottom: 20px;
}

//info-card块css
.info-card {
  height: 68px;
  line-height: 68px;
}

.info-card-item {
  float: left;
  margin: auto;
  width: 25%;
  vertical-align: middle;
}

.info-card-item-ch {
  margin-left: 30px;
  font-family: "FZLanTingHei-DB-GBK";
  text-align: center;
  font-size: 14px;
  color: #3e454d;
}

.info-card-item-num {
  padding-left: 10px;
  max-width: 90px;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #EB662B;
}

.vertical-line {
  float: right;
  margin-top: 18px;
  width: 1px;
  height: 33px;
  border-right: 1px solid #e8e8e8;
}

//loan-lists块css
//覆盖饿了么UI样式
#loan-list-bl {
  .el-tabs__item {
    padding: 0 30px;
    font-size: 16px;
    /*padding:0;*/
    /*margin:0 30px;*/
    /*display: inline-block;*/
    color: #34495e;
    font-family: "FZLanTingHei-DB-GBK";
    &:first-child {
      color: #EB662B;
    }
  }

  /*.el-tabs__item.is-active{*/
  /*border-bottom:2px solid #35c4f9;*/
  /*}*/

  .el-tabs__header {
    border-bottom: none;
  }

  .is-active {
    color: #EB662B;
  }

  .el-tabs__active-bar {
    /*display: none;*/
    background-color: #EB662B;
  }
  .el-tabs__active-bar {
    bottom: 3px;
    height: 0.1em;
  }
}

</style>



// WEBPACK FOOTER //
// MyLoan_bl.vue?6f1593b4